import { combineReducers } from "redux";
import loginSeller from "./login";
import agentInfo from "./agentInfo";
import sellerData from "./sellerData";

export default combineReducers({
  token: loginSeller,
  agent_info: agentInfo,
  seller_data: sellerData
});